/**
 * UsersInfoRemapper
 *
 * Maps UsersInfoDto (data layer) → UsersInfoEntity (domain).
 * Flutter source: lib/data/models/users_info.dart
 */
import type { UsersInfoDto } from '@/data/dtos/info/usersInfoDto';
import type { JsonObject } from '@/data/types/json';
import type { UsersInfoEntity } from '@/domain/entities/info/usersInfoEntity';

export class UsersInfoRemapper {
  static fromDto(dto: UsersInfoDto): UsersInfoEntity {
    return {
      userId: dto.userId,
      name: dto.name,
      username: dto.username,
      peerUserId: dto.peerUserId,
      peerName: dto.peerName,
      peerUsername: dto.peerUsername,
      usersIds: dto.usersIds,
      owner: dto.owner,
    };
  }

  static fromJson(data: JsonObject): UsersInfoDto {
    return {
      userId: (data['userId'] as string | undefined) ?? '',
      // Flutter default: "_" (UsersInfo({this.peerUserId = "_"}))
      peerUserId: (data['peerUserId'] as string | undefined) ?? '_',
      usersIds: data['usersIds'] as string[] | undefined,
      name: (data['name'] as string | undefined) ?? '',
      username: data['username'] as string | undefined,
      peerName: data['peerName'] as string | undefined,
      peerUsername: data['peerUsername'] as string | undefined,
      owner: data['owner'] as string | undefined,
    };
  }

  static fromJsonList(dataList: JsonObject[]): UsersInfoDto[] {
    return dataList.map(UsersInfoRemapper.fromJson);
  }

  static toJson(dto: UsersInfoDto): JsonObject {
    return {
      userId: dto.userId,
      peerUserId: dto.peerUserId ?? '_',
      usersIds: dto.usersIds ?? null,
      name: dto.name,
      username: dto.username ?? null,
      peerName: dto.peerName ?? null,
      peerUsername: dto.peerUsername ?? null,
      owner: dto.owner ?? null,
    };
  }

  /** Map a `UsersInfoEntity` back to its DTO (shapes are identical). */
  static toDtoFromEntity(entity: UsersInfoEntity): UsersInfoDto {
    return { ...entity };
  }
}
